import { NovatiqLoadingSpinnerHelper } from '@/_helpers';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'novatiq-spinner',
  templateUrl: './novatiq-loading-spinner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgxSpinnerModule, TranslateModule]
})
export class NovatiqLoadingSpinnerComponent implements OnInit {
  readonly isLoading = signal(false);

  private readonly loadingSpinnerHelper = inject(NovatiqLoadingSpinnerHelper);
  private readonly ngxSpinner = inject(NgxSpinnerService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.loadingSpinnerHelper
      .getLoading()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((isLoading) => {
        this.isLoading.set(isLoading);
        if (isLoading) {
          void this.ngxSpinner.show();
        } else {
          void this.ngxSpinner.hide();
        }
      });
  }
}
